import React from 'react'
import FileCopyIcon from '@mui/icons-material/FileCopy';
import { EMPTY } from './Constants';

export default function OEIInput(props) {
    const [copy ,onCopy]=React.useState('Copy');
    const copyText=(value)=>{
      onCopy('Copied')
      navigator.clipboard.writeText(value);
    }
    return (
        <>
      {  props.readOnly === 'true' ?
    <div  className="oe-form-field">
<label className="oe-form-field__title" htmlFor="meeting-link-with-passcode">{props.label}</label>
<div className="flex">
  <input
    className="oe-form-field__control disable_input"
    id="meeting-link-with-passcode"
    disabled=""
    value={props.value}
    type={props.type || "text"} 
    onChange={(e) => {
      props.setValue(e.target.value)
    }}/>
  { props.copyIcon? <div className="flex">
      <span onClick={()=>{copyText(props.value)}} onMouseLeave={()=>onCopy('Copy')} className="tooltip copy-button text-blue cursor-point text-hover-light-blue m-left-6px material-icons font-size-18px">
      <FileCopyIcon fontSize='small'></FileCopyIcon>
       <div className="copy-button_tooltip">{copy}</div>
      </span>
    </div>:EMPTY
}
  </div>
</div>

:
<div className="oe-form-field">
 <label className="oe-form-field__title">{props.label}</label>
              <input
    type={props.type || "text"} 
    className="oe-form-field__control"
    value={props.value}
    onChange={(e) => {
      props.setValue(e.target.value)
    }}
/>
{ props.errorMessage!==EMPTY?
 <div className="oe-form-field__error">{props.errorMessage}</div>
 :EMPTY
}
</div> 

    }
        </>
    )
}
